import jsPDF from "jspdf";
import { drawReportHeader } from "./helpers/drawReportHeader";
import { drawGlobalFooter } from "./helpers/drawGlobalFooter";
import { drawShipmentSections } from "./helpers/drawShipmentSections";
import { generateSimplifiedReportPages } from "./helpers/generateSimplifiedReportPages";
import { generateDetailedReportPages } from "./helpers/generateDetailedReportPages";
import { getShipmentSections } from "./pdfUtils";

export async function exportTelemetryReport({
  onBeforeCapture,
  chartRef,
  stepsRef,
  reportData,
  reportType,
  telemetryInfo,
  alerts,
  isCancelled = () => false,
  setAllowCancel,
  isStandalone,
  variant,
}) {
  if (!chartRef?.current) {
    console.error("Ref de gráfica no disponible.");
    return;
  }

  const shipmentCode = reportData.shipmentData?.shipmentCode ?? "envio";
  const variantLabel = variant === "reduced" ? "Reducido" : "Completo";
  const tipo = reportType === 1 ? "Detallado" : "Simplificado";
  const fileName = `Informe-${tipo}-${variantLabel}_${shipmentCode}.pdf`;

  const timestamp = new Date().toLocaleString("es-ES", {
    timeZone: "Europe/Madrid",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const pdf = new jsPDF("p", "pt", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 40;
  const maxWidth = pageWidth - margin * 2;

  if (isCancelled()) return;

  await drawReportHeader(pdf, alerts, timestamp);
  if (setAllowCancel) setAllowCancel(false);

  const sections = await getShipmentSections(reportData);

  const bottomOfHeader = margin + 100;
  drawShipmentSections(pdf, bottomOfHeader, sections);

  if (isCancelled()) return;
  if (setAllowCancel) setAllowCancel(false);

  if (reportType === 1) {
    await generateDetailedReportPages({
      pdf,
      chartRef,
      stepsRef,
      reportData,
      telemetryInfo,
      alerts,
      margin,
      pageWidth,
      pageHeight,
      maxWidth,
      onBeforeCapture,
      isStandalone,
    });
  } else if (reportType === 2) {
    await generateSimplifiedReportPages({
      pdf,
      chartRef,
      reportData,
      alerts,
      margin,
      pageHeight,
      maxWidth,
      onBeforeCapture,
    });
  }

  drawGlobalFooter(pdf, margin, timestamp);

  pdf.save(fileName);
}
